import React, { useState, useEffect } from "react";
import { Search, X } from "lucide-react";
import { Button } from "src/shadcn/ui/button";
import { TextInputBox } from "src/components/ui";

interface SearchBarProps {
  onSearch: (searchTerm: string) => void;
  placeHolder?: string;
  currentSearch?: string;
  searchTermMaxLength?: number;
}

const SearchBar: React.FC<SearchBarProps> = ({
  onSearch,
  placeHolder,
  currentSearch = "",
  searchTermMaxLength = 200
}) => {
  const [searchTerm, setSearchTerm] = useState(currentSearch);
  const [disableSearch, setDisableSearch] = useState(true);

  useEffect(() => {
    setSearchTerm(currentSearch);
  }, [currentSearch]);

  useEffect(() => {
    setDisableSearch(searchTerm === currentSearch);
  }, [searchTerm, currentSearch]);

  const handleSearchClick = () => {
    if (searchTerm !== currentSearch) {
      onSearch(searchTerm);
    }
  };

  const handleClear = () => {
    setSearchTerm("");
    if (currentSearch !== "") {
      onSearch("");
    }
  };

  return (
    <form
      className="relative flex items-center gap-2 w-full max-w-md"
      onSubmit={(e) => {
        e.preventDefault();
        handleSearchClick();
      }}
    >
      <div className="relative flex-1">
        <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-secondary-900 z-20" />
        <TextInputBox
          id="search-bar"
          placeholder={placeHolder || "Search..."}
          value={searchTerm}
          onChange={setSearchTerm}
          maxLength={searchTermMaxLength}
          className="pl-10 pr-10 h-10 bg-background border-secondary-200 focus-visible:ring-2 focus-visible:ring-secondary-900 focus-visible:border-secondary-900 text-sm text-foreground placeholder:text-muted-400"
        />
        {searchTerm && (
          <button
            type="button"
            onClick={handleClear}
            className="absolute right-3 top-1/2 transform -translate-y-1/2 text-muted-400 hover:text-muted-600 transition-colors"
          >
            <X className="h-4 w-4" />
          </button>
        )}
      </div>
      <Button
        type="button"
        onClick={handleSearchClick}
        disabled={disableSearch}
        className="h-10 px-5 bg-secondary-900 text-background hover:bg-secondary-800 disabled:opacity-50 disabled:bg-secondary-300 transition-colors"
      >
        Search
      </Button>
    </form>
  );
};

export { SearchBar };
